// Server-seitiges Event-Logging (Backup zu gtag, fuer Attribution/Reporting).
import axios from "axios";
import { getAttributionPayload } from "./attribution";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function trackEvent(event, { value = null, session_id = null, meta = {} } = {}) {
  try {
    await axios.post(`${API}/tracking/event`, {
      event,
      value,
      session_id,
      attribution: getAttributionPayload(),
      meta,
    });
  } catch {
    // tracking darf nie den Flow blockieren
  }
}
